import { render, staticRenderFns } from "./personalInformation.vue?vue&type=template&id=ec6dbaf4&scoped=true&"
import script from "./personalInformation.vue?vue&type=script&lang=js&"
export * from "./personalInformation.vue?vue&type=script&lang=js&"
import style0 from "./personalInformation.vue?vue&type=style&index=0&id=ec6dbaf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6dbaf4",
  null
  
)

export default component.exports